import { Product, ProductType, FrameHeaderProduct } from '../';

export function IsFrameHeaderProduct(product: Product): product is FrameHeaderProduct {
  return (product as FrameHeaderProduct).productType === ProductType.FRAME_HEADER;
}
